import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const PerformanceLoadingState = () => {
    return (
        <Stack gap="16px">
            <PixelPlaceholderLoader
                height={24}
                width="100%"
            />
            <PixelPlaceholderLoader
                height={24}
                width="100%"
            />
            <PixelPlaceholderLoader
                height={24}
                width="100%"
            />
        </Stack>
    );
};
